import * as React from 'react';
import './AvailableSensors.scss';
import Icon from './Icons';
import { mergeClasses } from '../constants';
import { Tooltip } from '@rtkwlf/fenrir-react';

export type AvailableSensorsProps = {
  value: string;
  appliance: string;
  active: boolean;
};

const AvailableSensors = (props: AvailableSensorsProps) => {
  return (
    <div className="sensor-count-container">
      <div
        className={mergeClasses([
          'sensor-count-badge',
          props.active ? 'active-sensor-count-badge' : '',
        ])}
      >
        <Tooltip.Root>
          <Tooltip.Trigger asChild>
            <div style={{ color: '#8C8C8C' }}>
              <Icon.Info />
            </div>
          </Tooltip.Trigger>
          <Tooltip.Content side={'top'}>
            <Tooltip.Text>
              {props.active
                ? 'Sensors available to assign'
                : props.appliance === 'Virtual Log Collector'
                ? 'Request additional sensors'
                : 'Purchase required for additional sensors'}
            </Tooltip.Text>
          </Tooltip.Content>
        </Tooltip.Root>
        <h3 className="sensor-count-value ml-2">{props.value}</h3>
      </div>
      {props.appliance}
    </div>
  );
};

export default AvailableSensors;
